const getTextFromDescription = description => description && description.text || description

module.exports = getTextFromDescription
